import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { map } from 'rxjs'

export const logoutGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  // Get query params from the route being navigated to (e.g., /logout?client=x)
  const queryParams = route.queryParams

  return authService.logout(false).pipe(
    map(() => {
      router.navigate(['/login'], { queryParams })
      return false
    })
  )
}
